<template>
	<section class="small-12 flex justify-center feature animated fadeIn">
        <picture class="small-12 flex justify-center vertical-align">
            <div class="small-12 large-3 columns">
                <h1 class="small-12 text-center">
                    404
                </h1>
                <p class="small-12 text-center">
                    Whoops! Sorry, this isn't what you're looking for. Unless you wanted 
                    our 404 page. Then, you're in the right place!
                </p>
            </div>
        </picture>
    </section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Feature',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>